import {
	SYS_BORDER_RADIUS_MAX,
	SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_200_DARK,
	SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_DARK,
	SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_STROKE_DARK,
	SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_50,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledSegmentedControl = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	background: ${SYS_COLOR_SURFACE_NEUTRAL_600_DARK};
	border-radius: ${SYS_BORDER_RADIUS_MAX};
	padding: ${SYS_SPACE_FIXED_50};
`;

export const StyledButton = styled.button`
	box-sizing: border-box;
	display: flex;
	flex: 1;
	height: 40px;
	align-items: center;
	justify-content: center;
	background: transparent;
	font-family: AudiType, sans-serif;
	font-size: 13px;
	color: ${SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_200_DARK};
	z-index: 1;
	padding: ${SYS_SPACE_FIXED_150};
	cursor: pointer;
	border: none;
	border-radius: ${SYS_BORDER_RADIUS_MAX};
`;

export const StyledSlider = styled.div<{ $index: number; $count: number }>`
	position: absolute;
	top: ${SYS_SPACE_FIXED_50};
	left: ${SYS_SPACE_FIXED_50};
	width: calc((100% - (${SYS_SPACE_FIXED_50} * 2)) / ${({ $count }) => $count});
	height: calc(100% - (${SYS_SPACE_FIXED_50} * 2));
	background-color: ${SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_FILL_DARK};
	box-sizing: border-box;
	box-shadow: inset 0 0 0 1px ${SYS_COLOR_SURFACE_INTERACTIVE_SECONDARY_200_STROKE_DARK};
	border-radius: ${SYS_BORDER_RADIUS_MAX};
	transition: transform 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
	transform: translateX(calc(${({ $index }) => $index} * 100%));
	z-index: 0;
`;
